import React from "react";
import { makeStyles } from "@mui/styles";
import DatePickerControl from "../../helpers/DatePickerControl";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import FilterWrapper from "./FilterWrapper";
import { enGB } from 'date-fns/locale';

const useStyles = makeStyles((theme) => ({
    datePickersContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up("sm")]: {
            flexDirection: "row",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "column",
        },
    },
    fromDatePicker: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up("sm")]: {
            marginRight: theme.spacing(2),
            marginBottom: theme.spacing(0),
        },
        [theme.breakpoints.up("md")]: {
            marginRight: 0,
            marginBottom: theme.spacing(3),
        },
    },
}));

const HistoryDateFilter = ({
    dateFrom = null,
    dateTo = null,
    onFromDateChange,
    onToDateChange,
}) => {
    const classes = useStyles();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
            <FilterWrapper filterName="Date Range">
                <div className={classes.datePickersContainer}>
                    <DatePickerControl
                        className={classes.fromDatePicker}
                        label="From"
                        value={dateFrom}
                        onChange={(date) => onFromDateChange(date)}
                        maxDate={dateTo ?? new Date()}
                    />
                    <DatePickerControl
                        label="To"
                        value={dateTo}
                        onChange={(date) => onToDateChange(date)}
                        minDate={dateFrom}
                        maxDate={new Date()}
                    />
                </div>
            </FilterWrapper>
        </LocalizationProvider>
    );
};

export default HistoryDateFilter;
